import { css } from 'linaria';

export const root = css`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 4px;
`;
